import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../images/Logo.png";
import img6 from "../images/Whatsapp1.png";
import img1 from "../images/Mobile.png"
import img2 from "../images/email1.png";
import { Link as ScrollLink } from "react-scroll"; // Adjust the path as necessary

const Footer = () => {
  const [activeSection, setActiveSection] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  const handleSetActive = (section) => {
    setActiveSection(section);
  };


  


  // Same as in Header
  const handleNavigateAndScroll = (id) => {
    if (!isHome) {
      navigate("/", { replace: false });
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const offset = el.offsetTop - 70;
          window.scrollTo({ top: offset, behavior: "smooth" });
        }
      }, 100);
    } else {
      const el = document.getElementById(id);
      if (el) {
        const offset = el.offsetTop - 70;
        window.scrollTo({ top: offset, behavior: "smooth" });
      }
    }
  };

  const menuItems = [
    { id: "homeSection", label: "Home" },
    { id: "aboutSection", label: "About us" },
    { id: "collectionSection", label: "Collection" },
    { id: "contactSection", label: "Contact us" },
  ];

  return (
    <footer className="bg-secondary py-4">
      <div className="3xl:flex 4xl:gap-10 6xl:gap-24 8xl:gap-36 px-2 md:px-5 5xl:px-10 7xl:px-14 10xl:px-24 py-5 5xl:py-8 text-[#ffffff]">
        {/* Mobile Header */}
        <div className="block 3xl:hidden">
          <div className="flex justify-between items-center">
            <img className="w-[70px] sm:w-[100px] 8xl:w-[140px] 9xl:w-[150px] 10xl:w-[160px] 11xl:w-[230px]" src={Logo} alt="Logo" />
            <div className="font-sans">
              <a
                className=" font-bold border-2 rounded-full border-[#01AD31] bg-[#01AD31] px-2 py-1  flex"
                href="https://api.whatsapp.com/send?phone=919385572362"
              >
                <img className="w-7 h-7 items-center mt-2 justify-center" src={img6} alt="" />
                <span className="ml-2 w-[110px]">Chat on Whatsapp</span>
              </a>
            </div>
            
          </div>
        </div>

        <div className="font-sans mt-2 3xl:mt-0">
          <h1 className="font-bold hidden 3xl:block text-md 3xl:text-lg  7xl:text-xl 9xl:text-2xl 10xl:text-3xl ">ABOUT US</h1>
          <p className=" 3xl:w-[270px] 4xl:w-[340px] 5xl:w-[400px] 7xl:w-[430px] 5xl:text-md  7xl:text-lg  9xl:text-xl 10xl:text-2xl mt-2">
            PR Silks Sarees brings you the finest collection of pure silk and
            handloom silk sarees, woven with tradition and love. Every saree
            tells a story of heritage, craftsmanship, and timeless elegance.
          </p>
        </div>
        <div className="flex justify-between items-center  xl:gap-14 3xl:flex-row">
        <div className="font-sans  mt-2 lg:mt-2 ">
          <h2 className="font-bold text-lg  7xl:text-xl 9xl:text-2xl 10xl:text-3xl">Menu</h2>
          <ul className="space-y-3 5xl:text-md 7xl:text-lg 9xl:text-xl 10xl:text-2xl mt-2">
            {menuItems.map((item) =>
              isHome ? (
                <li key={item.id}>
                  <ScrollLink
                    to={item.id}
                    smooth={true}
                    duration={500}
                    offset={-70}
                    spy={true}
                    onSetActive={() => handleSetActive(item.id)}
                    className={`cursor-pointer sm:text-[15px]  ${
                      activeSection === item.id ? "" : ""
                    }`}
                  >
                    {item.label}
                  </ScrollLink>
                </li>
              ) : (
                <li
                  key={item.id}
                  onClick={() => handleNavigateAndScroll(item.id)}
                  className="cursor-pointer"
                >
                  {item.label}
                </li>
              )
            )}
          
          
          </ul>
        </div>
        <div className="font-sans -mt-9 7xl:-mt-12 ">
          <h2 className="font-bold text-lg 5xl:text-lg 7xl:text-xl 9xl:text-2xl 10xl:text-3xl">Contact Us</h2>
          <div className="space-y-3 5xl:text-md 7xl:text-lg 9xl:text-xl 10xl:text-2xl mt-2">
            <div className="flex items-center gap-1">
              <img className="w-[30px]  mb-2" src={img1} alt="Mobile" />
               <p><a className=' text-md sm:text-[15px]  ' href='tel:+919385572362'>9385572362</a></p>
            </div>
            <div className="flex items-center gap-1">
              <img className="w-[30px]  mb-2" src={img2} alt="Email" />
             <p><a className=' text-md sm:text-[15px]  ' href='mailto:prsilks001@gmail.com'>prsilks001@gmail.com</a></p>
          </div>
          </div>
        </div>
        </div>
        <div className="font-sans hidden 3xl:block">
          <a
            className=" font-bold border-2 rounded-full border-[#01AD31] bg-[#01AD31] px-2 py-2  10xl:px-3 10xl:py-3 flex"
            href="https://api.whatsapp.com/send?phone=919385572362"
          >
            <img className="w-7 h-7 5xl:w-9 5xl:h-9 9xl:w-11 9xl:h-11 10xl:w-12 10xl:h-12" src={img6} alt="" />
            <span className="ml-2 text-[15px] 5xl:text-[17px] flex justify-center items-center 9xl:text-[22px] 10xl:text-[24px] 10xl:font-semibold">Chat on Whatsapp</span>
          </a>
        </div>
         <div className="border  justify-between block 3xl:hidden mt-3 border-[#FBB14B] "></div>
      </div>

     
      {/* Footer for larger screens */}
      <div className="px-2 md:px-5 5xl:px-10 7xl:px-14 10xl:px-24 ">
        <div className="border hidden 3xl:block 4xl:justify-between w-full border-[#ffffff] "></div>
        <div className="4xl:flex 4xl:justify-between 4xl:items-center 4xl:py-4 5xl:py-4 7xl:py-6 10xl:py-8 11xl:py-10">
          <img className="w-[70px] sm:w-[100px] 8xl:w-[140px] 9xl:w-[150px] 10xl:w-[160px] 11xl:w-[230px]  hidden 4xl:block" src={Logo} alt="Logo" />
          <p className="text-[#ffffff] hidden 4xl:block  px-6  mb-3  4xl:text-md  10xl:text-3xl ">
            cc 2025 PR SILKS SAARES All rights reserved
          </p>
          <p className="text-[#ffffff] text-center block  mb-2 3xl:mt-4  4xl:hidden  4xl:text-xl  10xl:text-3xl ">
            cc 2025 PR SILKS SAARES All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
